/**
 * 登录业务
 * @author Caesar Liu
 * @date 2019/3/27 22:33
 */
import request from '../utils/request'

/**
 * 账号登录
 */
export function loginByAccount (data) {
  return request.post('/login/account', data)
}

/**
 * 微信登录
 */
export function loginByWechat (data) {
  return request.post('/login/wechat', data)
}
